export enum LogoutReason {
    Idle = 'idle',
    Click = 'click',
    Error = 'error'
}
